export var convertButterImageToImageData = function (butterImage) {
    if (typeof butterImage === 'string') {
        console.error('Butter image is a string, therefore it will not have an alt property');
        return {
            src: butterImage,
            alt: '',
        };
    }
    return {
        src: butterImage.url,
        alt: butterImage.alt,
    };
};
